import React, {Fragment} from 'react';
import './Spinner.css';

export const JustSpinner = ({style}) => {
    return(
        <div id='nprogress'>
            <div className='spinner-icon' style={style}/>
        </div>
    )
};

export const TextSpinner = () => {
    return(
        <div id='nprogress'>
            <div className='spinner'>
                <div className='spinner-icon'/>
            </div>
        </div>
    )
};


export const SpinnerWithProgressBar = ({progress}) => {
    const style = {
        width: progress+'%'
    };
    return(
        <Fragment>
        <div id='nprogress'>
            {/*<div className="progress" style={{height: 5}}>*/}
                {/*<div className="progress-bar" role="progressbar" style={style} aria-valuenow="25"*/}
                     {/*aria-valuemin="0" aria-valuemax="100"/>*/}
            {/*</div>*/}
            <div className='bar' style={style}>
                <div className='peg'/>
            </div>
            <div className='spinner'>
                <div className='spinner-icon'/>
            </div>
        </div>
        </Fragment>
    )
};


